import React from 'react';

const SettingsSection = ({ title, icon: Icon, children, className = '' }) => {
  return (
    <div className={`bg-gray-800 rounded-lg p-4 sm:p-6 ${className}`}>
      <div className="flex items-center space-x-2 mb-4 sm:mb-6">
        {Icon && <Icon className="text-xl sm:text-2xl text-blue-500" />}
        <h3 className="text-lg sm:text-xl font-bold text-white">{title}</h3>
      </div>
      <div className="space-y-4 sm:space-y-6">
        {children}
      </div>
    </div>
  );
};

export default SettingsSection;
